import hash from 'object-hash';
import {createLruCache} from '@contentlab/utils/cache';

export interface TtsCacheValue {
  audioUrl: string;
  mimeType: string;
}

export interface TtsCacheApi {
  get: (key: string) => TtsCacheValue | undefined;
  set: (key: string, value: TtsCacheValue) => void;
  isCached: (url: string | null) => boolean;
  makeTtsKey: (text: string, voiceId: string) => string;
  clear: () => void;
}

const lru = createLruCache<TtsCacheValue>({
  maxEntries: 10,
  onEvict: (_key, _val) => {
    try {
      URL.revokeObjectURL(_val.audioUrl);
    } catch {
      /* noop */
    }
  },
});

const makeKey = (text: string, voiceId: string): string =>
  `${voiceId}:${hash(text)}`;

const isCached = (url: string | null): boolean => {
  if (!url) return false;
  return Array.from(lru.keys()).some((key) => {
    const v = lru.peek(key);
    return v?.audioUrl === url;
  });
};

const ttsCache: TtsCacheApi = {
  get: (key) => lru.get(key),
  set: (key, value) => lru.set(key, value),
  isCached,
  makeTtsKey: makeKey,
  clear: () => {
    Array.from(lru.keys()).forEach((key) => {
      const v = lru.peek(key);
      if (v?.audioUrl) {
        try {
          URL.revokeObjectURL(v.audioUrl);
        } catch {
          /* noop */
        }
      }
    });
    lru.clear();
  },
};

export default ttsCache;
